<template>
    <div>
        <div class="logo_div">
            <div class="logo_title">京东 · 万品京选</div>
        </div>

        <div style="padding: 20px; position: absolute; bottom: 80px; width: 100%; text-align: center">
            <van-button type="primary" size="large"
                @click="wx_login"
            >
                微信一键登录
            </van-button>

            <div style="margin-top: 20px" @click="super_login">超级会员登录</div>
            <div style="margin-top: 50px" @click="not_login">暂不登录</div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_mini_login",

        methods:{
            wx_login(){
                this.navigateTo("true");
                // let openid = this.$common.gloabl_wx_openid;
                // // openid="otyOg4ozV6nx9neuSClF0EQonk-Y";
                // if(openid){
                //     this.$getGloabl_WxUserinfo(openid, ()=>{
                //         this.$router.push("select")
                //     })
                // }
            },

            super_login(){
                this.$router.push("super_login")
            },

            not_login(){
                // this.$router.back();
                this.navigateTo("false");
            },

            navigateTo(autologin) {
                this.$wx.miniProgram.reLaunch({
                    url: "../wp_wx_login/wp_wx_login?" + this.serialize({
                        _t: Date.now(),
                        /* 本次消息的唯一编码，用于微信小程序将处理结果反馈给H5 */
                        cmd: "do",
                        /* 业务指令 */
                        autologin: autologin /* 业务指令的执行参数 */
                    })
                });

            },

            serialize(data) {
                let s = "";
                for (let p in data)
                    s += "&" + p + "=" + encodeURIComponent(data[p]).replace(/\+/gm, "%2B");
                s = s.length > 0 ? s.substring(1) : s;
                return s;
            },
        }
    }
</script>

<style scoped>

    .logo_div {
        width: 100%;
        margin-top: -100px;
        height: 300px;
        background-color: #E52212;
        border-radius: 60px;

    }

    .logo_title{
        font-size: 40px;
        font-weight: bolder;
        color:white;
        position: absolute;
        width: 100%;
        text-align: center;
        margin-top: 170px;
    }

</style>